import React from 'react';
import NextLink from 'next/link';
import { useRouter } from 'next/router';

import { Heading } from '@ads-core/components';
import { Table } from '@ads-core/components';
import { ProjectOverviewFieldsProps } from 'components/ProjectOverview';

type ResultsTableProps = {
  items: ProjectOverviewFieldsProps[];
  currentFilterRegion?: string;
  currentFilterCity?: string;
};

export const ResultsTable = ({
  items,
  currentFilterRegion,
  currentFilterCity,
}: ResultsTableProps) => {
  const router = useRouter();

  if (items.length) {
    return (
      <Table
        title="Projectenoverzicht"
        columns={[
          {
            dataKey: 'city',
            title: 'Plaats',
            style: { width: '22%', padding: 0 },
          },
          {
            dataKey: 'workingArea',
            title: 'Werkgebied',
            style: { width: '22%', padding: 0 },
          },
          {
            dataKey: 'typeOfWork',
            title: 'Soort werkzaamheden',
            style: { width: '22%', padding: 0 },
          },
          {
            dataKey: 'startDate',
            title: 'Startdatum',
            style: { width: '12%', padding: 0 },
          },
          {
            dataKey: 'endDate',
            title: 'Einddatum',
            style: { width: '12%', padding: 0 },
          },
        ]}
        data={items.map((item) => {
          const { city, endDate, startDate, typeOfWork, workingArea, detailPage } = item.fields;

          return {
            fields: {
              city: city.value,
              startDate: startDate.value,
              endDate: endDate.value,
              typeOfWork: typeOfWork.value,
              workingArea: workingArea.value,
            },
            onRowClick: () => {
              if (detailPage.value.href) {
                router.push(detailPage.value.href);
              }
            },
            link: detailPage.value.href ? <NextLink href={detailPage.value.href} /> : undefined,
          };
        })}
      />
    );
  }

  return (
    <Heading size="h5" as="h3">
      {noResultsParams(currentFilterCity, currentFilterRegion)}
    </Heading>
  );
};

const noResultsParams = (city?: string, region?: string) => {
  const params = [region, city].filter(Boolean).join(' en ');

  return `Geen resultaten gevonden voor ${params}`;
};
